import SuccessPopup from '@/components/custom/InfoPopups/SuccessPopup';
import { CrmExportHandlerProps } from '@/features/crm_system/lib/_core/crmSystem';
import { airtableDefaultConfigurationElements } from '@/lib/utils/crm/airtable/defaultConfiguration';
import { getAirtableMetaDataFromConfiguration } from '@/lib/utils/crm/airtable/getAirtableMetaDataFromConfiguration';
import { countErrorsInRowForFields } from '@/pages/ManageSurvey/ExportSurvey/utils';
import Airtable from 'airtable';

export function exportSurveyToAirtable({
  data,
  selectedColumns,
  exportInvalidRows,
}: CrmExportHandlerProps) {
  try {
    selectedColumns = ['Question', 'Values', ...selectedColumns];
    const dataToExport = (
      exportInvalidRows
        ? data.refinedData
        : data.refinedData.filter(
            (row) => countErrorsInRowForFields(row, selectedColumns) === 0
          )
    ).map((row) => {
      const onlySelectedColumns = selectedColumns.reduce((acc, key) => {
        if (key in row) {
          acc[key] = row[key];
        }
        return acc;
      }, {});
      return onlySelectedColumns;
    });
    const _fields = dataToExport;
    console.log(_fields);
    if (!data.matched_configuration_with_default)
      throw new Error('No matched configuration found');
    const { baseId, apiKey, tableNameOrId } =
      getAirtableMetaDataFromConfiguration(
        data.matched_configuration_with_default
      );
    console.log(baseId, apiKey, tableNameOrId);
    Airtable.configure({ apiKey });
    const base = Airtable.base(baseId!).table(tableNameOrId!);
    const fields: Record<string, string> = {};
    _fields?.forEach((val) => {
      const columnName =
        val[airtableDefaultConfigurationElements.parameter.question.columnName]
          ?.value;
      if (columnName) {
        fields[columnName] = val['Values'].value;
      }
    });
    if (Object.keys(fields).length === 0) throw new Error('No fields found');
    base
      .create([{ fields }])
      .then(() => {
        console.log(fields);
        SuccessPopup('Data exported successfully to Airtable');
      })
      .catch((err) => {
        console.log(err);
        throw new Error('Error creating record in Airtable');
      });
  } catch (error) {
    console.error('Error exporting to Airtable:', error);
    throw error;
  }
}
